import React from 'react';
import { AlertBannerTW } from '../../../../tailwindComponents/alertBannerTW/AlertBannerTW';
import { IHasTestData } from '../../../../ui-toolkit/test-utilities/IHasTestData';
import { ISigningAppointmentRescheduleResponse } from '../../../../types/signingAppointment/ISigningAppointmentRescheduleResponse';
import { useFindMostRecentReschedule } from '../../../../utilities/order/scheduling/useFindMostRecentReschedule';
import { useSelectAppointmentFromPathParam } from '../../../../utilities/order/scheduling/useSomeAppointmentFromParam';
import { mergeTests } from '../../../../ui-toolkit/test-utilities/mergeTests';

const determineAlertMessage = (reschedule: ISigningAppointmentRescheduleResponse) => {
  if (reschedule.isInternal) return 'Appointment Date, Time, or Location has been updated by Spruce';
  return 'Appointment Time has been updated by the Notary';
};

export const RescheduleContainer: React.FC<IHasTestData> = ({ ...rest }) => {
  const { appointmentFromPath } = useSelectAppointmentFromPathParam();

  const mostRecentReschedule = useFindMostRecentReschedule(appointmentFromPath);
  if (!mostRecentReschedule) return null;

  return (
    <div
      className={'pb-4'}
      data-test-id={mergeTests(rest['data-test-id'], 'reschedule-container')}
      data-test-class={mergeTests(rest['data-test-class'], 'reschedule-container')}
    >
      <AlertBannerTW data-test-id={rest['data-test-id']} data-test-class={rest['data-test-class']}>
        {determineAlertMessage(mostRecentReschedule)}
      </AlertBannerTW>
    </div>
  );
};
